import {
    apiRequest,
    bobotPenilaianIndividuDetail, 
    bobotPenilaianIndividuUpdate,
} from "../../../../../../services/adapters/master/bobotPenilaianIndividuService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", bobotPenilaianIndividuDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotPenilaianIndividuUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository